import * as React from 'react';
import { ErrorBoundary } from 'bernie-view';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { PropertyShareActions, PropertyShareActionsSplitted } from '@shared-ui/lodging-property-details';
import { withSharedUiPropertyDetails } from './shared-ui-property-details';
import { usePropertyDetailsQueryCSRExperiment } from './use-property-details-query';
const ShareActionsWrapper = ({
  inputs
}) => {
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  return React.createElement(ErrorBoundary, {
    label: "share.actions.wrapper"
  }, React.createElement(Experiment, {
    name: "Dated_PDP_Split_ProductDetailsQuery"
  }, React.createElement(ExperimentControl, null, React.createElement(PropertyShareActions, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(PropertyShareActionsSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))));
};
export const SharedUiShareActionsWrapper = withSharedUiPropertyDetails(ShareActionsWrapper);
SharedUiShareActionsWrapper.displayName = 'SharedUiShareActionsWrapper';